import { useSelector } from 'react-redux';

import type { AppState } from '../types';
import { initialState } from './reducer';
import type { LayoutState } from './types';

const getStateSubtree = (state: AppState): LayoutState => state.layout || initialState;

export const getIsSidebarCollapsed = (state: AppState): boolean =>
  getStateSubtree(state).isSidebarCollapsed;

export const useGetIsSidebarCollapsed = () => useSelector(getIsSidebarCollapsed);
